import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFocalPoint20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconFocalPoint20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4.746 3.496c-.69 0-1.25.56-1.25 1.25v2.558a.75.75 0 1 1-1.5 0V4.746a2.75 2.75 0 0 1 2.75-2.75h2.558a.75.75 0 0 1 0 1.5zm11.762 3.808V4.746c0-.69-.56-1.25-1.25-1.25h-2.557a.75.75 0 0 1 0-1.5h2.557a2.75 2.75 0 0 1 2.75 2.75v2.558a.75.75 0 0 1-1.5 0m-1.25 9.204h-2.557a.75.75 0 0 0 0 1.5h2.557a2.75 2.75 0 0 0 2.75-2.75v-2.557a.75.75 0 0 0-1.5 0v2.557c0 .69-.56 1.25-1.25 1.25m-11.762-1.25c0 .69.56 1.25 1.25 1.25h2.558a.75.75 0 0 1 0 1.5H4.746a2.75 2.75 0 0 1-2.75-2.75v-2.557a.75.75 0 0 1 1.5 0zm6.506-4.376a.88.88 0 1 0 0-1.76.88.88 0 0 0 0 1.76"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFocalPoint20);
